import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { CitationLink } from './CitationLink';

interface ChatSummaryProps {
    summary: string;
    citationLinks?: Record<string, { urls: string[]; source: string; title: string; summary?: string }>;
}

export const ChatSummary: React.FC<ChatSummaryProps> = ({ summary, citationLinks }) => {
    return (
        <div className='chat-summary'>
            <span className='chat-summary-title'>Summary:</span>
            <div className='chat-summary-text'>
                <ReactMarkdown 
                    remarkPlugins={[remarkGfm]}
                    components={{
                        a: ({ node, href, children, ...props }) => (
                            <CitationLink 
                                href={href || '#'} 
                                citationLinks={citationLinks}
                                {...props}
                            >
                                {children}
                            </CitationLink>
                        )
                    }}
                >
                    {summary}
                </ReactMarkdown>
            </div>
        </div>
    );
};
